<template>
    <div>
        <div class="comments">
            <single-comment
                v-for="comment in allComments"
                :key="comment.id"
                :comment="comment"
            />
        </div>

        <div v-if="canPost">
            <form v-loading="loading" @submit.prevent="save">
                <textarea
                    v-model="body"
                    class="form-input"
                    :rows="rows"
                    required
                />

                <div class="float-left">
                    <label v-if="displayPropertyAccessAllowedControls">
                        <input
                            v-model="propertyAccessAllowed"
                            type="checkbox"
                            name="property_access_allowed"
                        >
                        Clear premises issues.
                    </label>
                    <label v-if="displayPropertyAccessDeniedControls">
                        <input
                            v-model="propertyAccessDenied"
                            type="checkbox"
                            name="property_access_denied"
                        >
                        Premises access denied by customer.
                    </label>
                </div>

                <div class="text-right mt-md">
                    <button type="submit" class="btn btn-md is-primary px-3xl">
                        Kommentera
                    </button>
                </div>
            </form>
        </div>

        <div v-if="error" class="bg-danger text-white p-md mt-md">
            {{ error }}
        </div>
    </div>
</template>

<script>
    import SingleComment from './Comment';

    export default {
        components: {
            SingleComment,
        },

        props: {
            comments: {
                required: true,
                type: Array,
            },
            refType: {
                required: true,
                type: String,
            },
            refId: {
                type: [Number, String],
                required: true,
            },
            canPost: {
                type: [Boolean],
                required: true,
            },
            rows: {
                type: [Number, String],
                default: 7,
            },
            displayPropertyAccessAllowedControls: {
                type: Boolean,
                default: false,
            },
            displayPropertyAccessDeniedControls: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                body: '',
                error: '',
                allComments: this.comments,
                loading: false,
                propertyAccessAllowed: false,
                propertyAccessDenied: false,
            };
        },

        methods: {
            save() {
                if (! this.body) {
                    return this.showError('Ett meddelande måste anges.');
                }

                const data = {
                    body: this.body,
                    ref_type: this.refType,
                    ref_id: this.refId,
                    property_access_allowed: this.propertyAccessAllowed,
                    property_access_denied: this.propertyAccessDenied,
                };

                this.loading = true;

                axios.post(route('api.comments.store'), data)
                    .then(response => {
                        this.clearForm();

                        this.allComments.unshift(response.data.comment);
                        this.loading = false;
                    })
                    .catch(error => {
                        this.showError(error.response.data.message);
                        this.loading = false;
                    });
            },

            clearForm() {
                this.body = '';
                this.propertyAccessAllowed = false;
                this.propertyAccessDenied = false;
            },

            showError(error) {
                this.error = error;
            },
        },
    };
</script>